export const isValidFileSize = (maxFileSizeInMB: number, file: File) => {
    const fileSizeInMB = file.size / (1024 * 1024);
    return fileSizeInMB <= maxFileSizeInMB / (1024 * 1024);
};
